/**
 * Radiation dosimeter. Worn gear that protects nothing and tells you something, which is what an
 * accessory slot is for.
 */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { ArmorItem } from '@/sim/items/itemContract';

export const RADIATION_DOSIMETER = {
  id: 'radiationDosimeter',
  kind: 'armor',
  label: 'Radiation dosimeter',
  description: 'Ticks upward. The Coldbrook manual says a healthy worker keeps it under forty.',
  rarity: 'common',
  weightKg: 0.2,
  stackLimit: 1,
  equip: {
    slots: ['accessory1', 'accessory2', 'accessory3'],
    statDeltas: { perception: 1 },
    armor: NO_ARMOR,
    damageModifiers: [],
  },
} as const satisfies ArmorItem;
